import passwordValidator from 'password-validator';

export const passwordMinLength = 8;
export const passwordUppercaseCharactersCount = 1;
export const passwordLowercaseCharactersCount = 1;
export const passwordDigitsCount = 2;
export const passwordSymbolsCount = 1;
export const longPasswordMinLength = 15;

const passwordSchema = new passwordValidator();
const passwordSchemaLong = new passwordValidator();

passwordSchema
  .is().min(passwordMinLength)
  .has().uppercase(passwordUppercaseCharactersCount)
  .has().lowercase(passwordLowercaseCharactersCount)
  .has().digits(passwordDigitsCount)
  .has().symbols(passwordSymbolsCount);

passwordSchemaLong
  .is().min(longPasswordMinLength);

export function validatePassword(password: string): boolean | string {
  const result = passwordSchema.validate(password, { list: true }) as string[];

  if (result.length > 0) {
    const alternativeResult = passwordSchemaLong.validate(password);

    if (alternativeResult) {
      return true;
    }

    return `password_${result[0]}`;
  }

  return true;
}

